import { Component, OnInit, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'app-social-share-preview',
  templateUrl: 'social-share-preview.component.html',
  styleUrls: ['./social-share-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SocialSharePreviewComponent implements OnInit {
  readonly socialMedia = input<any>(undefined);
  readonly title = input<any>(undefined);
  readonly image = input<any>(undefined);
  readonly imageWidth = input<any>(undefined);
  readonly contentType = input<any>(undefined);
  readonly description = input<any>(undefined);
  readonly message = input<any>(undefined);
  readonly emailTitle = input<any>(undefined);
  readonly emailBody = input<any>(undefined);
  readonly url = input<any>(undefined);

  ngOnInit() { }

  getImage() {
    return this.image() || '../../../assets/images/missing.png';
  }
}
